import { render } from "./SeriesItem.vue?vue&type=template&id=58ebe2b2"
import script from "./SeriesItem.vue?vue&type=script&lang=js"
export * from "./SeriesItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__